function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { Configuration } from "../Shared/Configuration";
import { Ajax } from "./Ajax";
export var CustomFormApiService = /*#__PURE__*/function () {
  function CustomFormApiService() {
    _classCallCheck(this, CustomFormApiService);

    var config = new Configuration();
    this._appRoot = config.GetAppRoot();
  }

  _createClass(CustomFormApiService, [{
    key: "GetForm",
    value: function GetForm(FormGuid) {
      var url = "".concat(this._appRoot, "/Api/CustomFormApi/GetForm?FormGuid=").concat(FormGuid);
      return Ajax.Get(url);
    }
  }, {
    key: "GetFormFields",
    value: function GetFormFields(FormGuid) {
      var url = "".concat(this._appRoot, "/Api/CustomFormApi/GetFormFields?FormGuid=").concat(FormGuid);
      return Ajax.Get(url);
    }
  }, {
    key: "GetContactById",
    value: function GetContactById(contactId) {
      var url = "".concat(this._appRoot, "/Api/CustomFormApi/GetContactById?contactId=").concat(contactId);
      return Ajax.Get(url);
    }
  }, {
    key: "PostFormData",
    value: function PostFormData(formData) {
      var url = "".concat(this._appRoot, "/Api/CustomFormApi/PostFormData");
      return Ajax.Post(url, formData);
    }
  }, {
    key: "GetConfigurations",
    value: function GetConfigurations() {
      var url = "".concat(this._appRoot, "/Api/CustomFormApi/GetConfigurations");
      return Ajax.Get(url);
    }
  }]);

  return CustomFormApiService;
}();